import React from 'react';
import AppConfig from 'Config/AppConfig';
import NavigationUtils from '../../../Utils/NavigationUtils';
import c from '../../../Components/AuthLayout/authContent.module.less';

export const Auth2Error = () => {
  const email = window.__INITIAL_STATE && window.__INITIAL_STATE.auth2_email;
  const loginPath = `/${AppConfig.ACCOUNTS_PREFIX}login/`;

  return (
    <>
      <h1 className={c.title}>Oops! Did you use the right account?</h1>
      <p className={c.text}>
        It looks like the email address you entered {email && <span className={c.email}>({email}) </span>}
        is the wrong one.
      </p>
      <p className={c.text}>
        If you&#39;re like most of us, you have more than one email address. Can you check to be sure you&#39;re using
        the right one?
      </p>
      <p className={c.text}>
        If you&#39;re certain you&#39;re using the correct email address, please contact your administrator.
      </p>
      <div className={c.actions}>
        <a
          className={c.btnPrimary}
          href={loginPath}
          id="submit-id-login"
          onClick={(e) => NavigationUtils.navigate(e, loginPath)}
        >
          Try a different account
        </a>
      </div>
    </>
  );
};

export default Auth2Error;
